import React from 'react';
import Logo from './ui/Logo';

const Footer = () => {
  return (
    <footer className="bg-brand-primary border-t border-brand-secondary/30 pt-32 pb-16">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-20 mb-32">
          <div className="md:col-span-6">
            {/* Clearly visible and proportionally balanced footer logo */}
            <Logo className="h-8 md:h-10 w-auto mb-10" />
            <p className="text-white text-xl font-light max-w-md leading-relaxed opacity-80">
              An independent business platform building ideas into ventures that move business forward.
            </p>
          </div>
          
          <div className="md:col-span-6 grid grid-cols-2 lg:grid-cols-4 gap-16">
            <div>
              <h4 className="text-white text-[12px] tracking-[0.3em] uppercase font-bold mb-10">Businesses</h4>
              <ul className="flex flex-col space-y-6 text-[16px] font-light text-white/70">
                <li><a href="#consulting" className="hover:text-brand-accent transition-colors">Consulting</a></li>
                <li><a href="#mobility" className="hover:text-brand-accent transition-colors">Mobility</a></li>
                <li><a href="#capital" className="hover:text-brand-accent transition-colors">Capital</a></li>
                <li><a href="#learn" className="hover:text-brand-accent transition-colors">Learn</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-white text-[12px] tracking-[0.3em] uppercase font-bold mb-10">Company</h4>
              <ul className="flex flex-col space-y-6 text-[16px] font-light text-white/70">
                <li><a href="#about" className="hover:text-brand-accent transition-colors">About</a></li>
                <li><a href="#perspective" className="hover:text-brand-accent transition-colors">Perspective</a></li>
                <li><a href="#contact" className="hover:text-brand-accent transition-colors">Contact</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white text-[12px] tracking-[0.3em] uppercase font-bold mb-10">EPOQ Network</h4>
              <ul className="flex flex-col space-y-6 text-[16px] font-light text-white/70">
                <li>
                  <a 
                    href="https://epoqmobility.com/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="hover:text-brand-accent transition-colors"
                  >
                    EPOQ Mobility
                  </a>
                </li>
                <li>
                  <a 
                    href="https://epoqlearn.com/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="hover:text-brand-accent transition-colors"
                  >
                    EPOQ Learn
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white text-[12px] tracking-[0.3em] uppercase font-bold mb-10">Legal</h4>
              <ul className="flex flex-col space-y-6 text-[16px] font-light text-white/70">
                <li><a href="#privacy" className="hover:text-brand-accent transition-colors">Privacy</a></li>
                <li><a href="#cookies" className="hover:text-brand-accent transition-colors">Cookies</a></li>
                <li className="pt-6"><a href="#linkedin" className="text-white font-semibold hover:text-brand-accent transition-colors tracking-widest uppercase text-[12px]">LinkedIn</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-brand-secondary/30 pt-16 flex flex-col md:flex-row justify-between items-center text-[13px] md:text-[14px] text-brand-secondary font-light tracking-[0.1em]">
          <p className="mb-6 md:mb-0 uppercase tracking-[0.2em] text-center md:text-left">
            EPOQ Assets v/Kristian Vangsgaard · Copenhagen, Denmark
          </p>
          <p className="text-white/40">&copy; {new Date().getFullYear()} EPOQ Assets. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;